import { Button, Modal } from "react-bootstrap"
import ThemedModal from "../../../@ui/Modal/ThemedModal"
import { PublicTransportDownloadSource } from "../../../types/LayerAdmin/PublicTransportDownloadSource";

export interface ConfirmMultiIgnoreModalProps {
    show: boolean;
    onClose: () => void;
    sources: PublicTransportDownloadSource[];
    onConfirmed: () => void;
    isIgnoring: boolean;
    failureReason?: string;
}

export const ConfirmMultiRetryModal = ({ show, onClose, sources, isIgnoring, onConfirmed, failureReason }: ConfirmMultiIgnoreModalProps) => {
    return <>
        <ThemedModal centered show={show} onHide={onClose}>
            <Modal.Header>
                <Modal.Title>Retry Download</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to retry <span className="text-warning">{sources.length} sources</span>{failureReason ? " with a failure reason of '" + failureReason + "'" : ""}?</p>
                <ul style={{overflowY: "auto", maxHeight: "200px"}} className="list-unstyled">
                    {sources.map((source, index) => (
                        <li key={index}>
                            <strong>{source.name}</strong>
                        </li>
                    ))}
                </ul>
                <p>Support will receive an email once this process finishes.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Cancel</Button>
                <Button variant="danger" onClick={onConfirmed} disabled={isIgnoring}>Yes</Button>
            </Modal.Footer>
        </ThemedModal>
    </>
}